import { allMovies, editorPicks } from '@/mocks/movies';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function EditorSection() {
  return (
    <section id="editor" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-8">
        <SectionHeading
          eyebrow="编辑推荐"
          title="我们为什么推荐这几部"
          subtitle="不只是打个高分，而是说清楚它们适合什么样的观众、在什么场景下最打动人心。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {editorPicks.map((pick) => {
            const movie = allMovies.find((item) => item.id === pick.movieId);
            if (!movie) return null;
            return (
              <article
                key={pick.movieId}
                className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors duration-300 hover:border-primary-300 md:flex-row md:p-5"
              >
                <div className="flex shrink-0 gap-4">
                  <div className="relative h-40 w-28 overflow-hidden rounded-md bg-background-200">
                    <img
                      src={movie.poster}
                      alt={`${movie.title} 海报`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                </div>
                <div className="flex min-w-0 flex-1 flex-col gap-2">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 font-label text-xs font-bold text-foreground-950">
                      <i className="ri-star-fill text-[10px]" aria-hidden="true" />
                      {movie.rating.toFixed(1)}
                    </span>
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-xs font-medium text-secondary-900">
                      {movie.genre}
                    </span>
                  </div>
                  <h3 className="font-heading text-base font-black leading-snug text-foreground-950 md:text-lg">
                    {pick.headline}
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{pick.reason}</p>
                  <p className="mt-auto font-label text-xs text-foreground-500">
                    {movie.year} · {movie.director} 执导 · 主演 {movie.cast}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}